<div [formGroup]="destinationControl" class="form-block" *ngIf="destinationControl && authSchemes">
  <!-- Stream URL filed -->
  <mat-form-field>
    <mat-label>Stream URL
      <app-required-field [validator]="destinationControl.controls.streamUrl.validator"></app-required-field>
    </mat-label>
    <input
      appInputFilter [controlRef]="destinationControl.controls.streamUrl"
      [filterSpaceAtStart]="true" [filterSpaces]="true"
      matInput autocomplete="off" placeholder="Stream URL" type="text" formControlName="streamUrl"
    >
    <mat-error
      *ngIf="destinationControl.controls.streamUrl.hasError('required') &&
        (destinationControl.controls.streamUrl.dirty ||
        destinationControl.controls.streamUrl.touched)"
    >
      Property is always required and can`t be empty
    </mat-error>
    <mat-error
      *ngIf="destinationControl.controls.streamUrl.hasError('multipleHyphens') &&
        (destinationControl.controls.streamUrl.dirty ||
        destinationControl.controls.streamUrl.touched)"
    >
      Consecutive hyphens (e.g. "--" or more) are not allowed.
    </mat-error>
  </mat-form-field>

  <!-- Stream key field -->
  <mat-form-field>
    <mat-label>Stream Key
      <app-required-field [validator]="destinationControl.controls.streamKey.validator"></app-required-field>
    </mat-label>
    <input
      appInputFilter [controlRef]="destinationControl.controls.streamKey"
      [filterSpaceAtStart]="true" [filterSpaces]="true"
      matInput autocomplete="off" placeholder="Stream Key" type="text" formControlName="streamKey"
    >
    <mat-error
      *ngIf="destinationControl.controls.streamKey.hasError('required') &&
        (destinationControl.controls.streamKey.dirty ||
        destinationControl.controls.streamKey.touched)"
    >
      Property is always required and can`t be empty
    </mat-error>
  </mat-form-field>

  <mat-form-field class="port">
    <mat-label>Port
      <app-required-field [validator]="destinationControl.controls.port.validator"></app-required-field>
    </mat-label>
    <input matInput autocomplete="off" placeholder="port" type="number" formControlName="port">
    <mat-error
      *ngIf="destinationControl.controls.port.hasError('required') &&
        (destinationControl.controls.port.dirty ||
        destinationControl.controls.port.touched)"
    >
      Property is always required and can`t be empty
    </mat-error>
  </mat-form-field>

  <!-- Authorization schema selector -->
  <mat-form-field>
    <mat-label>Authorization Schema
      <app-required-field [validator]="destinationControl.controls.authScheme.validator"></app-required-field>
    </mat-label>
    <mat-select formControlName="authScheme" (selectionChange)="onChangeScheme()">
      <mat-option *ngFor="let scheme of authSchemes" [value]="scheme.name">
        {{ scheme.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div *ngIf="selectedScheme?.auth">

    <!-- Username field -->
    <mat-form-field>
      <mat-label>Username
        <app-required-field [validator]="destinationControl.controls.username.validator"></app-required-field>
      </mat-label>
      <input matInput autocomplete="off" placeholder="Username" type="text" formControlName="username">
    </mat-form-field>

    <!-- Password field -->
    <mat-form-field>
      <mat-label>Password
        <app-required-field [validator]="destinationControl.controls.password.validator"></app-required-field>
      </mat-label>
      <input matInput autocomplete="off" placeholder="Password" type="text" formControlName="password">
    </mat-form-field>
  </div>

  <!-- AKAMAI Stream ID -->
  <div *ngIf="selectedScheme?.streamId">
    <mat-form-field>
      <mat-label>Stream ID
        <app-required-field [validator]="destinationControl.controls.akamaiStreamId.validator"></app-required-field>
      </mat-label>
      <input matInput autocomplete="off" placeholder="Stream ID" type="number" formControlName="akamaiStreamId">
    </mat-form-field>
  </div>
</div>
